import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    instances: [],
    maximumScreenWidth: null,
    init: function() {
      this.construct();
      window.addEventListener( 'resize', () => this.resize() );
    },
    construct: function() {
      this.maximumScreenWidth = window.screen.width;
      this.instances = gsap.utils.toArray( '.service-hero' );
      this.instances?.map( ( $componentEl ) => {
        if ( $componentEl._marqueeElements ) return $componentEl;

        $componentEl._marqueeElements = $componentEl.querySelectorAll( '.js-marquee' );
        if ( $componentEl._marqueeElements ) {
          $componentEl._marqueeElements.forEach( ( $el, index ) => {
            $componentEl._marqueeElements[index]._items = gsap.utils.toArray( $componentEl._marqueeElements[index].querySelectorAll( '.js-marquee-item' ) )?.map( ( $item ) => () => {
              return $item.cloneNode( true );
            } );
          } );
        }

        return $componentEl;
      } );

      this.createLoopedItems();
      this.animate();
    },
    resize: function() {
      if ( this.maximumScreenWidth !== window.screen.width ) {
        this._instances = [];
        this.construct();
      }
    },
    animate: function() {
      this.instances.forEach( ( $componentEl ) => {
        $componentEl._marqueeElements.forEach( ( $marqueeEl, index ) => {
          if ( $marqueeEl?._tween ) {
            $marqueeEl?._tween.scrollTrigger.refresh();
          } else {
            $marqueeEl._tween = gsap.to( $marqueeEl, {
              x: () => index === 0 ? '-100vw' : '100vw',
              scrollTrigger: {
                trigger: $marqueeEl,
                scrub: true,
              },
            } );
          }
        } );
      } );
    },
    createLoopedItems: function() {
      this.instances.forEach( ( $componentEl ) => {
        if ( !$componentEl._marqueeElements || $componentEl._marqueeElements.length === 0 ) return;

        $componentEl._marqueeElements.forEach( ( $marqueeEl, index ) => {
          $marqueeEl.innerHTML = '';
          let marqueeWidth = $marqueeEl.offsetWidth;
          while ( marqueeWidth < ( this.maximumScreenWidth * 2 ) ) {
            $marqueeEl._items.forEach( ( createEl, index ) => {
              $marqueeEl.appendChild( createEl() );
            } );

            marqueeWidth = $marqueeEl.offsetWidth;
          }
        } );
      } );
    },
    finalize: function() {},
  };

  app.registerComponent( 'service-hero', COMPONENT );
} )( app );
